import api from 'core/api';

export const getSupport = () => api.get(`/support`);
export const postSupport = (data) => api.post('/support', data);
